/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import React from 'react';
import {getSearch, hasFiltering, makeFilteredItemsSelector, makeItemsTagsSelector} from "../../selectors/finder";
import {getAEMResource, getHomepage} from "../../selectors/generic";
import {initializeFavoriteRecipes, initializeRecipes} from "../../actions/recipes";
import {fetchTags} from "../../actions/aem";
import {activateFinder, setSearch} from "../../actions/finder";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {FavoriteRecipeType, RecipeType} from "../../data/recipes.model";
import {ProductFinderType} from "../../data/finders.model";
import {Finder} from "../templates/Finder";
import {browserHistory} from "../../config/redux.store";
import {ConnectedRouter} from 'connected-react-router';
import {areTagLoaded} from "../../selectors/tags";
import {areRecipesLoading, getFavoriteRecipes, makeRecipeSearchFilter, matchRecipeWithSearch, sortedRecipesSelector} from "../../selectors/recipes";
import RecipeGridCard from "../molecules/cards/RecipeGridCard";
import {GirdListCtaCard} from "../molecules/cards/GirdListCtaCard";
import {FinderTypeAhead} from "../organisms/finders/FinderTypeAhead";
import {PromotionalBanner} from "../molecules/promotions/PromotionalBanner";
import {SkeletonTypes} from "../atoms/effects/skeletons/utils/SkeletonTypes";

export class RecipeFinder extends React.Component {

    static defaultProps = {
        resource: {}
    };

    static propTypes = {
        recipes: PropTypes.arrayOf(PropTypes.shape(RecipeType)),
        searchedRecipes: PropTypes.arrayOf(PropTypes.shape(RecipeType)),
        favoriteRecipes: PropTypes.arrayOf(PropTypes.shape(FavoriteRecipeType)),
        resource: PropTypes.shape(ProductFinderType),
        hasFiltering: PropTypes.bool,
        tagsLoaded: PropTypes.bool,
        recipesLoading: PropTypes.bool,
        availableTags: PropTypes.array,
        initializeFavoriteRecipes: PropTypes.func
    };

    static SortingOptions = [
        { label: "Sort by relevance", value: "weight" },
        { label: "Sort by date", value: "referenceDate" },
        { label: "Sort alphabetically", value: "referenceTitle" },
    ];

    constructor(props) {
        super(props);

        this.renderRecipeCard = this.renderRecipeCard.bind(this);
        this.renderSubheader = this.renderSubheader.bind(this);
    }


    componentDidMount() {
        this.props.fetchTags();
        this.props.initializeRecipes(this.props.model);
        this.props.initializeFavoriteRecipes();
    }

    componentDidUpdate(oldProps) {
        if ((oldProps.tagsLoaded !== true && this.props.tagsLoaded === true && Object.keys(this.props.resource).length > 0)
            || (this.props.tagsLoaded === true && oldProps.resource !== this.props.resource)) {
            this.props.activateFinder({ type: 'recipe', filters: this.props.resource.filters })
        }
    }

    renderRecipeCard = ({ item }) => {
        return <RecipeGridCard item={item} isFavorite={!!this.props.favoriteRecipes.find(favorite => favorite.recipeId === item.id)} />
    };

    renderSubheader() {
        if (!this.props.resource) {
            return null;
        }

        const { thematicTitle, highlight1, highlight2 } = this.props.resource;

        if (this.props.hasFiltering || (!highlight1 && !highlight2)) {
            return null;
        }

        return <PromotionalBanner thematicTitle={thematicTitle} highlight1={highlight1} highlight2={highlight2} />
    }

    render() {
        const { resource, hasFiltering, recipes, searchedRecipes, recipesLoading, search, setSearch, availableTags } = this.props;

        return (<ConnectedRouter history={browserHistory}>
            <Finder resource={resource}
                    items={searchedRecipes}
                    hasFiltering={hasFiltering}
                    card={this.renderRecipeCard}
                    ctaCard={resource.ctacard && <GirdListCtaCard {...resource.ctacard} />}
                    availableTags={availableTags}
                    loading={recipesLoading}
                    skeletonType={SkeletonTypes.RECIPE_FINDER}
                    sortingOptions={RecipeFinder.SortingOptions}

                    search={<FinderTypeAhead
                        key="typeahead"
                        items={recipes}
                        emptyLabel={resource.noResultsMessage || ""}
                        search={search && search.startsWith("searchid:") ? searchedRecipes[0] && searchedRecipes[0].title : search}
                        placeholder={resource.searchBarPlaceholder}
                        filter={(option, props) => matchRecipeWithSearch(option, props.text)}
                        setSearch={setSearch} />}

                    renderSubheader={this.renderSubheader} />
        </ConnectedRouter>);
    }

}


const mapStateToProps = () => {
    const recipesSelector = makeFilteredItemsSelector(sortedRecipesSelector);
    const searchedItems = makeRecipeSearchFilter(recipesSelector, getSearch);
    const tagsSelector = makeItemsTagsSelector(sortedRecipesSelector);

    return (state, ownProps) => ({
        resource: getAEMResource(state, ownProps.model),
        homepageResource: getHomepage(state),
        recipes: recipesSelector(state),
        searchedRecipes: searchedItems(state),
        favoriteRecipes: getFavoriteRecipes(state),
        hasFiltering: hasFiltering(state),
        tagsLoaded: areTagLoaded(state),
        recipesLoading: areRecipesLoading(state),
        search: getSearch(state),
        availableTags: tagsSelector(state)
    })
};

const mapActionToProps = {
    initializeRecipes,
    initializeFavoriteRecipes,
    fetchTags,
    activateFinder,
    setSearch,
};

export default connect(mapStateToProps, mapActionToProps)(RecipeFinder);
